<template>
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Pages"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="ManageUser-ResetPassword"
        transform="translate(-746, -656)"
        fill="#404948"
        fill-rule="nonzero"
      >
        <g id="Group-8" transform="translate(605, 465)">
          <g
            id="check_circle_FILL0_wght400_GRAD0_opsz24"
            transform="translate(141, 191)"
          >
            <path
              id="Shape"
              d="M8.6,14.6 L15.65,7.55 L14.25,6.15 L8.6,11.8 L5.75,8.95 L4.35,10.35 L8.6,14.6 Z M10,20 C8.61666667,20 7.31666667,19.7375 6.1,19.2125 C4.88333333,18.6875 3.825,17.975 2.925,17.075 C2.025,16.175 1.3125,15.1166667 0.7875,13.9 C0.2625,12.6833333 0,11.3833333 0,10 C0,8.61666667 0.2625,7.31666667 0.7875,6.1 C1.3125,4.88333333 2.025,3.825 2.925,2.925 C3.825,2.025 4.88333333,1.3125 6.1,0.7875 C7.31666667,0.2625 8.61666667,0 10,0 C11.3833333,0 12.6833333,0.2625 13.9,0.7875 C15.1166667,1.3125 16.175,2.025 17.075,2.925 C17.975,3.825 18.6875,4.88333333 19.2125,6.1 C19.7375,7.31666667 20,8.61666667 20,10 C20,11.3833333 19.7375,12.6833333 19.2125,13.9 C18.6875,15.1166667 17.975,16.175 17.075,17.075 C16.175,17.975 15.1166667,18.6875 13.9,19.2125 C12.6833333,19.7375 11.3833333,20 10,20 Z M10,18 C12.2333333,18 14.125,17.225 15.675,15.675 C17.225,14.125 18,12.2333333 18,10 C18,7.76666667 17.225,5.875 15.675,4.325 C14.125,2.775 12.2333333,2 10,2 C7.76666667,2 5.875,2.775 4.325,4.325 C2.775,5.875 2,7.76666667 2,10 C2,12.2333333 2.775,14.125 4.325,15.675 C5.875,17.225 7.76666667,18 10,18 Z"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
